import React from 'react';
import clsx from 'clsx';

import { Button, Modal, Text } from '@auspost/postmaster-react';

import { ReactComponent as TruckIcon } from 'assets/truck.svg';
import { CalculatedDelivery } from 'models/shipments';
import { getCalculatedDeliveryDateText } from 'utils/date.utils';

import { INLINE_EDD_CLOSE_BUTTON_TEST_ID, INLINE_EDD_SEARCHED_EDD_TEST_ID } from '../InlineEdd.test-ids';

import styles from '../InlineEdd.module.scss';

interface EstimateResultModalProps {
  state: string | null;
  postcode: string | null;
  estimate: CalculatedDelivery | null;
  handleClose: () => void;
}

const EstimateResultModal: React.FC<EstimateResultModalProps> = ({ state, postcode, estimate, handleClose }) => {
  if (!estimate || !postcode) return null;
  return (
    <>
      <Modal.Header closeButton={false} className={clsx(styles.inlineEddModalHeader, styles.center)}>
        <h3 className={styles.inlineEddModalHeading}>
          Expected arrival in {state} {postcode}:
        </h3>
      </Modal.Header>
      <Modal.Content>
        <div className={styles.estimationContent}>
          <TruckIcon width={36} height={36} className={styles.trackIcon} />
          <Text variant='body-large' weight='medium' data-testid={INLINE_EDD_SEARCHED_EDD_TEST_ID}>
            {getCalculatedDeliveryDateText(estimate)}
          </Text>
        </div>
        <Text variant='body' className={styles.inlineEddModalContent}>
          <span>These dates won’t update automatically like they do for most parcels.</span>
          <span>To check for updates, you’ll need to re-calculate them each time you track this parcel.</span>
        </Text>
      </Modal.Content>
      <Modal.Footer alignment='right'>
        <Button
          size='medium'
          variant='primary'
          className={clsx(styles.inlineEddModalButton, styles.closeButton)}
          onClick={handleClose}
          data-testid={INLINE_EDD_CLOSE_BUTTON_TEST_ID}
        >
          Close and continue
        </Button>
      </Modal.Footer>
    </>
  );
};

export default EstimateResultModal;
